import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

const AGENT_OVERRIDE_URL = () => resolveApiUrl("/api/seo-guard/agent-override");

const cache = new Map();
const inflight = new Map();

const normalizePathname = (pathname) => {
  if (!pathname || typeof pathname !== "string") {
    return "/";
  }
  const withoutQuery = pathname.split("?")[0];
  const withLeadingSlash = withoutQuery.startsWith("/") ? withoutQuery : `/${withoutQuery}`;
  return withLeadingSlash.replace(/\/+$/, "") || "/";
};

const toSafeOverride = (row) => {
  if (!row || typeof row !== "object") {
    return null;
  }
  const result = {};
  if (typeof row.index_enabled === "boolean") {
    result.index = row.index_enabled;
  }
  if (typeof row.follow_enabled === "boolean") {
    result.follow = row.follow_enabled;
  }
  if (typeof row.title === "string" && row.title.trim()) {
    result.title = row.title.trim();
  }
  if (typeof row.description === "string" && row.description.trim()) {
    result.description = row.description.trim();
  }
  if (typeof row.canonical_url === "string" && row.canonical_url.trim()) {
    result.canonicalUrl = row.canonical_url.trim();
  }
  return Object.keys(result).length ? result : null;
};

export async function loadAgentSeoOverride({ agentId, pathname }) {
  if (agentId === null || agentId === undefined || agentId === "") {
    return null;
  }
  const normalizedPathname = normalizePathname(pathname);
  const cacheKey = `${String(agentId)}::${normalizedPathname}`;

  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }
  if (inflight.has(cacheKey)) {
    return inflight.get(cacheKey);
  }

  const requestPromise = (async () => {
    try {
      const response = await axios.get(AGENT_OVERRIDE_URL(), {
        withCredentials: true,
        params: {
          agent_id: agentId,
          pathname: normalizedPathname,
        },
      });
      const safe = toSafeOverride(response?.data?.override);
      cache.set(cacheKey, safe || null);
      return cache.get(cacheKey);
    } catch (error) {
      cache.set(cacheKey, null);
      return null;
    } finally {
      inflight.delete(cacheKey);
    }
  })();

  inflight.set(cacheKey, requestPromise);
  return requestPromise;
}

export function resetAgentSeoOverrideCache() {
  cache.clear();
  inflight.clear();
}
